import React, { FC, useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { useHistory, withRouter, useLocation } from 'react-router-dom';
import fetch from '../../utils/Api';
import ReactLoading from 'react-loading';

import APPROVE_IMAGE from '../../images/cashout-approve.png';
import REJECT_IMAGE from '../../images/cashout-reject.png';

type PageDisbursementConfirmation = {};

type queryParamsType = {
  account_name: string;
  account_number: string;
  action_status: string;
  bank_name: string;
  branch: string;
  disbursement_number: string;
  total_amount: string;
};

const PageDisbursementConfirmation: FC<PageDisbursementConfirmation> = () => {
  const history = useHistory();
  const location = useLocation();

  const [status, setStatus] = useState<boolean | string>(false);
  const [token, setToken] = useState<string>('');
  const [body, setBody] = useState<{ action_status; disbursement_number }>({
    action_status: '',
    disbursement_number: '',
  });

  useEffect(() => {
    const query: queryParamsType = getQueryParamsUrl();
    if (location.pathname.split('/').length > 2) {
      setToken(location.pathname.split('/')[2]);
      setBody({
        action_status: query.action_status,
        disbursement_number: query.disbursement_number,
      });
    }
  }, []);

  useEffect(() => {
    if (token) {
      doFetchData();
    }
  }, [token, body]);

  const doFetchData = () => {
    setStatus(false);
    fetch()
      .put('/users/disbursement/confirmation/' + token, body)
      .then((res) => {
        if (body.action_status == 'approve') {
          setStatus('confirm');
        } else {
          setStatus('reject');
        }
      })
      .catch((err) => {
        if (err?.response?.data?.error?.status_code === 404) {
          setStatus('notfound');
        } else if (err?.response?.data?.error?.status_code === 400) {
          setStatus('expired');
        } else {
          setStatus('error');
        }
        console.log(
          err?.response?.data?.error,
          '==============================',
        );
      });
  };

  const getQueryParamsUrl = () => {
    const checker = new URLSearchParams(location.search);
    let objParams: queryParamsType = {
      account_name: '',
      account_number: '',
      action_status: '',
      bank_name: '',
      branch: '',
      disbursement_number: '',
      total_amount: '',
    };
    for (let pair of checker.entries()) {
      objParams = {
        ...objParams,
        [pair[0]]: pair[1],
      };
    }
    return objParams;
  };

  const onPendingCashoutPressed = () => {
    history.push({
      pathname: '/user_dashboard/wallet-history',
      state: { fromCashoutConfirmationPage: true }
    });
  };
  const onGoBackPressed = () => {
    history.push('/');
  };

  const renderLoader = () => {
    return (
      <div className="disbursement-confirmation__inner-container">
        <ReactLoading type={'spin'} color={'#159953'} height={50} width={50} />
      </div>
    );
  };

  const renderConfirmed = () => {
    return (
      <div className="disbursement-confirmation__inner-container">
        <KickImage
          src={APPROVE_IMAGE}
          className="disbursement-confirmation__image-status"
        />
        <p className="disbursement-confirmation__status-title">
          Withdrawal Request Submitted
        </p>
        <p className="disbursement-confirmation__description">
          Your request has been accepted. If you don’t recognize this activity,
          immediately change your password or contact our Customer Service.
        </p>
        <div
          className="disbursement-confirmation__status-button-approve"
          onClick={onPendingCashoutPressed}
        >
          <p className="disbursement-confirmation__status-button-approve-text">
            Go To Pending Cash Out
          </p>
        </div>
      </div>
    );
  };

  const renderRejected = () => {
    return (
      <div className="disbursement-confirmation__inner-container">
        <KickImage
          src={REJECT_IMAGE}
          className="disbursement-confirmation__image-status"
        />
        <p className="disbursement-confirmation__status-title">
          Withdrawal Request Cancelled
        </p>
        <p className="disbursement-confirmation__description">
          Your request has been cancelled. If you don’t recognize this activity,
          immediately change your password or contact our Customer Service.
        </p>
        <div
          className="disbursement-confirmation__status-button-approve"
          onClick={onPendingCashoutPressed}
        >
          <p className="disbursement-confirmation__status-button-approve-text">
            Go To Pending Cash Out
          </p>
        </div>
      </div>
    );
  };

  const renderExpired = () => {
    return (
      <div className="disbursement-confirmation__inner-container">
        <KickImage
          src={REJECT_IMAGE}
          className="disbursement-confirmation__image-status"
        />
        <p className="disbursement-confirmation__status-title">
          Withdrawal request timed out
        </p>
        <p className="disbursement-confirmation__description">
          This token exceeds 5 minutes time limit. To create a new
          withdrawal/cash out request, please redo the steps and tap on the
          email confirmation link before it expires.
        </p>
        <div
          className="disbursement-confirmation__status-button-approve"
          onClick={onGoBackPressed}
        >
          <p className="disbursement-confirmation__status-button-approve-text">
            Go Back
          </p>
        </div>
      </div>
    );
  };

  const renderError = () => {
    return (
      <div className="disbursement-confirmation__inner-container">
        <KickImage
          src={REJECT_IMAGE}
          className="disbursement-confirmation__image-status"
        />
        <p className="disbursement-confirmation__status-title">
          Oops, it seems that we didn’t get your request
        </p>
        <p className="disbursement-confirmation__description">
          To help eliminate this issue, do check on your internet connection and
          attempt your request again.
        </p>
        <div
          className="disbursement-confirmation__status-button-approve"
          onClick={doFetchData}
        >
          <p className="disbursement-confirmation__status-button-approve-text">
            Try Again
          </p>
        </div>
      </div>
    );
  };

  const renderNotFound = () => {
    return (
      <div className="disbursement-confirmation__inner-container">
        <KickImage
          src={REJECT_IMAGE}
          className="disbursement-confirmation__image-status"
        />
        <p className="disbursement-confirmation__status-title">
          Invalid information submitted
        </p>
        <p className="disbursement-confirmation__description">
          Carefully review your submission to withdraw from your balance. We
          cannot authorize this transaction due to some mismatch of information
          on your information submitted.
        </p>
        <div
          className="disbursement-confirmation__status-button-approve"
          onClick={doFetchData}
        >
          <p className="disbursement-confirmation__status-button-approve-text">
            Try Again
          </p>
        </div>
      </div>
    );
  };

  const renderPage = () => {
    switch (status) {
      case false:
        return renderLoader();
      case 'confirm':
        return renderConfirmed();
      case 'reject':
        return renderRejected();
      case 'expired':
        return renderExpired();
      case 'error':
        return renderError();
      case 'notfound':
        return renderNotFound();
      default:
        return renderLoader();
    }
  };

  return (
    <div className="disbursement-confirmation__Container">{renderPage()}</div>
  );
};

const DisbursementConfirmation = withRouter(PageDisbursementConfirmation);

export default DisbursementConfirmation;
